// extracted by mini-css-extract-plugin
export var createdDate = "_nh-1";
export var divider = "_nh-2";
export var headerDivider = "_nh-3";
export var messagesCard = "_nh-0";
export var messagesContainer = "_nh-7";
export var messagesContainerWrapper = "_nh-4";
export var pointerCapturingButtonBoxes = "_nh-a";
export var showLeftPanelButton = "_nh-9";
export var showMoreButton = "_nh-c";
export var showMoreButtonContainer = "_nh-b";
export var summaryTitle = "_nh-6";
export var systemMessageCardWrapper = "_nh-d";
export var topButtons = "_nh-8";
export var withPadding = "_nh-5";